import { useQuery } from '@tanstack/react-query';
import { machineAPI, projetDessinsAPI } from '../../services/api';
import { PlansListResponse } from '../../types/projetDessin';

/**
 * Plans techniques (« Tous les plans »). Keys start with 'projet-dessins' — the /api/projet-dessins
 * slug the realtime-invalidation middleware broadcasts — so a plan saved by anyone refreshes them.
 */
export const plansKeys = {
  root: ['projet-dessins'] as const,
  list: (params: Record<string, unknown>) => ['projet-dessins', 'plans', params] as const,
};

export function usePlansTechniques(params: { groupe?: string; machine_id?: number | ''; q?: string; skip: number; limit: number }) {
  return useQuery<PlansListResponse>({
    queryKey: plansKeys.list(params),
    queryFn: () => projetDessinsAPI.plans(params),
    keepPreviousData: true,
  });
}

/** Machines for the filter (reference data: not under the plans root). */
export function usePlanMachines() {
  return useQuery({
    queryKey: ['plans-machines-options'],
    queryFn: () => machineAPI.getAll(0, 1000).then((r) => r.items),
    staleTime: 10 * 60_000,
  });
}
